/** Same build string on login and in the sidebar. Dev: `dev-666.957`. Live: `v1.58.2.20260828.1`. */
export function formatAppVersion(webVersion: string, apiActive?: string | null): string {
  const web = (webVersion || '').replace(/^v/i, '');
  const combined = apiActive ? `${web}.${apiActive}` : web;
  if (web.startsWith('dev-') || web.startsWith('[version]')) {
    return combined;
  }
  return `v${combined}`;
}
